import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Typography
} from '@one-thd/sui-atomic-components';
import { StoreHeroContext } from '../../../StoreHero.context';

const FeatureBlock = ({ feature, setStoreOverlayOpen, iconEl }) => {
  const { store } = useContext(StoreHeroContext);
  const { storeDetailsPageLink } = store || {};

  const isStoreLayout = feature.title === 'Store Layout';
  const hrefPath = isStoreLayout ? null : `${storeDetailsPageLink}${feature.path}`;

  return (

    <a
      className="sui-flex sui-mt-4 sui-mb-4 sui-justify-between"
      data-testid="feature-block-component"
      href={hrefPath}
      onClick={isStoreLayout ? () => setStoreOverlayOpen(true) : () => { }}
    >
      <div>
        <Typography variant="h3">
          <span className="sui-text-lg sui-font-w-bold">{feature?.title}</span>
        </Typography>
        <div className="sui-text-sm">
          {feature?.description}
        </div>
      </div>
      {(iconEl) ? (
        <div className="sui-flex sui-flex-col sui-justify-center">
          {iconEl}
        </div>
      ) : (
        <img
          alt=""
          src={`https://assets.thdstatic.com/images/v1/${feature?.icon}`}
          style={{ objectFit: 'contain' }}
          height={40}
          width={isStoreLayout ? 40 : 60}
          title="Image Title"
        />
      )}
    </a>
  );
};

FeatureBlock.propTypes = {
  feature: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired
  }).isRequired,
  setStoreOverlayOpen: PropTypes.func,
  iconEl: PropTypes.element
};

FeatureBlock.defaultProps = {
  setStoreOverlayOpen: () => { },
  iconEl: null
};

FeatureBlock.displayName = 'StoreFeatureCard';

export { FeatureBlock };
